import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const ProfilesCreated = () => {
  const { profilesCreated, profilesCreatedChange } = useSelector(
    (state) => state.marketing.profileRetention
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <NumberDisplay value={profilesCreated} disableAnimation={isUserQa} />
      <PercentChanged
        changeValue={profilesCreatedChange}
        toolTip="Percent change from previous month"
        showBorder
      />
    </>
  );
};

export default ProfilesCreated;
